import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';
import AutocompleteCAreas from 'src/components/ui/Autocomplete/connectors/AutocompleteCAreas';

import FieldRepeaterCFormik from './FieldRepeaterCFormik';

const FieldRepeaterCAreas = ({ options = [], excludeIds = [], ...props }) => {
	const repeatShape = null;

	const linesConvertor = useCallback(
		(name) => (option, i) => {
			return {
				props: {
					type: FORM_LINE_TYPES.custom,
					params: {
						Component: AutocompleteCAreas,
						name: `${name}.${i}`,
						options,
						excludeIds,
					},
				},
			};
		},
		[excludeIds, options],
	);

	return (
		<FieldRepeaterCFormik
			repeatShape={repeatShape}
			linesConvertor={linesConvertor}
			{...props}
		/>
	);
};

FieldRepeaterCAreas.propTypes = {
	options: PropTypes.array,
	excludeIds: PropTypes.arrayOf(
		PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	),
};

export default FieldRepeaterCAreas;
